"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InfoPopup = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styles_1 = require("@mui/material/styles");
const Popper_1 = __importDefault(require("@mui/material/Popper"));
const IconButton_1 = __importDefault(require("@mui/material/IconButton"));
const Close_1 = __importDefault(require("@mui/icons-material/Close"));
const HelpOutline_1 = __importDefault(require("@mui/icons-material/HelpOutline"));
const useSetPopupRef_1 = require("../../hooks/useSetPopupRef");
const usePopupRef_1 = require("../../hooks/usePopupRef");
const HtmlHelper_1 = require("../../services/HtmlHelper");
const StyledInfoPopup = (0, styles_1.styled)('div')(({ theme }) => ({
    backgroundColor: theme.palette.custom.surfaceMedium,
    width: '350px',
    padding: '20px',
    paddingRight: '30px',
    boxShadow: '3px 4px 15px 3px #75757566',
    color: theme.palette.custom.textLight,
    fontSize: '0.9em',
    '& p': {
        borderBottom: `1px solid ${theme.palette.custom.surfaceDark}`,
        paddingBottom: '10px',
        whiteSpace: 'pre-wrap',
        fontSize: '13px',
    },
    '& p:last-of-type': {
        borderBottom: 'none',
        paddingBottom: 0,
    },
    '& table': {
        width: '100%',
        marginTop: theme.spacing(2),
    },
    '& td, th': {
        border: `1px solid ${theme.palette.custom.surfaceDark}`,
        padding: '2px 8px',
        textAlign: 'left',
    },
}));
const StyledInfoIconContainer = (0, styles_1.styled)('div')(() => ({
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '3px',
}));
const StyledInfoIcon = (0, styles_1.styled)(HelpOutline_1.default)(({ theme }) => ({
    fontSize: '1.3em',
    cursor: 'pointer',
    '&:hover': {
        color: theme.palette.custom.textMedium,
    },
}));
const InfoPopup = ({ popId, infos = [], getCloseInfoRef }) => {
    const popupRef = (0, usePopupRef_1.usePopupRef)();
    const setPopupRef = (0, useSetPopupRef_1.useSetPopupRef)();
    const popupContentRef = (0, react_1.useRef)(null);
    // Remove empty items
    infos = infos
        .filter((i) => i)
        .map((i) => i.includes('<a ') ? i.replace('<a ', '<a target="_blank" ') : i);
    const handleInfoClick = (e) => {
        if (popId === (popupRef === null || popupRef === void 0 ? void 0 : popupRef.popId)) {
            setPopupRef(null);
        }
        else {
            setPopupRef({ popId, ref: e.target });
        }
    };
    const onClose = () => {
        setPopupRef(null);
    };
    (0, react_1.useEffect)(() => {
        const handleClickOutside = (event) => {
            if (popupContentRef.current &&
                !popupContentRef.current.contains(event.target)) {
                onClose();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    (0, react_1.useEffect)(() => {
        getCloseInfoRef && getCloseInfoRef(onClose);
    }, []);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(StyledInfoIconContainer, { children: (0, jsx_runtime_1.jsx)(StyledInfoIcon, { onClick: (e) => handleInfoClick(e) }) }), (0, jsx_runtime_1.jsx)(Popper_1.default, { id: popId, open: popId === (popupRef === null || popupRef === void 0 ? void 0 : popupRef.popId), placement: 'bottom-start', anchorEl: popupRef === null || popupRef === void 0 ? void 0 : popupRef.ref, style: { zIndex: 1300 }, children: (0, jsx_runtime_1.jsxs)(StyledInfoPopup, { ref: popupContentRef, children: [(0, jsx_runtime_1.jsx)(IconButton_1.default, { "aria-label": "close", sx: {
                                position: 'absolute',
                                right: '2px',
                                top: '2px',
                                color: 'primary.main',
                            }, onClick: onClose, children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }), infos.map((i, ind) => ((0, jsx_runtime_1.jsx)("p", { dangerouslySetInnerHTML: { __html: (0, HtmlHelper_1.sanitizeHtmlString)(i) } }, `info${ind}`)))] }) })] }));
};
exports.InfoPopup = InfoPopup;
